import { BUY_CAKE, MENU_CLICK } from "./sideBarTypes"
import { SIDE_MENU } from "./sideBarTypes"

const initialState = {
    ShowSideBar: false,
    menuToggle: true,
}

const SideBarReducer = (state = initialState, action) => {
    switch (action.type) {
        case MENU_CLICK:
            return {
                ...state,
                ShowSideBar: !state.ShowSideBar
            }
        case SIDE_MENU:
            return {
                ...state,
                menuToggle: !state.menuToggle
            }
        default:
            return state
    }
}

export default SideBarReducer;